<div class="configuration-title">
  <b>Page Configuration Settings</b>
</div>
<div class="form-group">
  <label for="new-ads-sort">New Offer Sets Sort</label>
  <div class="dropdown-container">
    <p-dropdown
      id="new-ads-sort"
      [options] ="newPageAdSortOptions"
      [style]="{'width':'15rem'}"
      [(ngModel)]="selectedNewPageAdSortOption">
    </p-dropdown>
  </div>
</div>
<div class="form-group">
  <label class="input-switch-label" for="new-ads-sort">Featured Offer Set First</label>
  <div class="input-switch-container">
    <p-inputSwitch
      id="featured-ads-first"
      [(ngModel)]="featuredAdsFirst"
      class="toggle-switch">
    </p-inputSwitch>
  </div>
</div>
<div class="form-group">
  <label for="used-ads-sort">Used Offer Sets Sort</label>
  <div class="dropdown-container">
    <p-dropdown
      id="used-ads-sort"
      [options] ="usedPageAdSortOptions"
      [style]="{'width':'15rem'}"
      [(ngModel)]="selectedUsedPageAdSortOption">
    </p-dropdown>
  </div>
</div>
<div class="form-group">
  <label for="show-title-in-dynamic-header">Show Offer Set Title in Dynamic Header
    <span class="pi pi-info-circle"
          pTooltip="Toggles whether the ad’s title appears above the offers in the dynamic header. Updates with the featured ad or VIN parameter."></span>
  </label>
  <div class="input-switch-container">
    <p-inputSwitch
      id="show-title-in-dynamic-header"
      [(ngModel)]="showTitleInDynamicHeader"
      class="toggle-switch">
    </p-inputSwitch>
  </div>
</div>
<div class="modal-button-wrapper">
  <button type="button" pButton (click)="updatePageConfiguration()" icon="pi pi-save" class="p-button-success modal-button" label="Save"></button>
</div>
